var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState, } from "react";
import { useWebgate } from "@xvia/webgate-connect";
import { getMyProfile } from "../../apis/profile";
import { getApiErrorMessage } from "../../apis/http";
var AuthContext = createContext(undefined);
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useWebgate(), accessToken = _b.accessToken, initialized = _b.initialized, portalConnect = _b.portalConnect, userInfo = _b.userInfo;
    var _c = useState(null), user = _c[0], setUser = _c[1];
    var _d = useState(null), profileError = _d[0], setProfileError = _d[1];
    var _e = useState(false), isLoadingProfile = _e[0], setIsLoadingProfile = _e[1];
    var requestIdRef = useRef(0);
    var isResolvingProfile = Boolean(accessToken) && !user && !profileError;
    var clearAuthenticatedState = useCallback(function () {
        requestIdRef.current += 1;
        setUser(null);
        setProfileError(null);
        setIsLoadingProfile(false);
    }, []);
    var refreshProfile = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var requestId, profile, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken) {
                        clearAuthenticatedState();
                        return [2 /*return*/, null];
                    }
                    requestId = requestIdRef.current + 1;
                    requestIdRef.current = requestId;
                    setIsLoadingProfile(true);
                    setProfileError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getMyProfile(accessToken)];
                case 2:
                    profile = _a.sent();
                    if (requestId === requestIdRef.current) {
                        setUser(profile);
                    }
                    return [2 /*return*/, profile];
                case 3:
                    error_1 = _a.sent();
                    if (requestId === requestIdRef.current) {
                        setUser(null);
                        setProfileError(getApiErrorMessage(error_1));
                    }
                    return [2 /*return*/, null];
                case 4:
                    if (requestId === requestIdRef.current) {
                        setIsLoadingProfile(false);
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [accessToken, clearAuthenticatedState]);
    var login = useCallback(function (options) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!portalConnect) {
                        throw new Error("Smartpass indisponivel no contexto atual.");
                    }
                    return [4 /*yield*/, portalConnect.login(options)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [portalConnect]);
    var logout = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!portalConnect) {
                        clearAuthenticatedState();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, portalConnect.logout()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [clearAuthenticatedState, portalConnect]);
    var register = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!portalConnect) {
                        throw new Error("Smartpass indisponivel no contexto atual.");
                    }
                    return [4 /*yield*/, portalConnect.register()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [portalConnect]);
    var accountManagement = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!portalConnect) {
                        throw new Error("Smartpass indisponivel no contexto atual.");
                    }
                    return [4 /*yield*/, portalConnect.accountManagement()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [portalConnect]);
    useEffect(function () {
        if (!initialized) {
            return;
        }
        if (!accessToken) {
            clearAuthenticatedState();
            return;
        }
        void refreshProfile();
    }, [accessToken, clearAuthenticatedState, initialized, refreshProfile]);
    var value = useMemo(function () { return ({
        accessToken: accessToken,
        accountManagement: accountManagement,
        agencyId: user === null || user === void 0 ? void 0 : user.agencyId,
        hasToken: Boolean(accessToken),
        hasPortalConnect: Boolean(portalConnect),
        initialized: Boolean(initialized),
        isAuthenticated: Boolean(accessToken && user),
        isLoadingAuth: !initialized || isLoadingProfile || isResolvingProfile,
        isLoadingProfile: isLoadingProfile,
        login: login,
        logout: logout,
        profileError: profileError,
        register: register,
        role: user === null || user === void 0 ? void 0 : user.role,
        smartpassUserInfo: userInfo,
        user: user,
        refreshProfile: refreshProfile,
    }); }, [
        accessToken,
        accountManagement,
        initialized,
        isResolvingProfile,
        isLoadingProfile,
        login,
        logout,
        portalConnect,
        profileError,
        refreshProfile,
        register,
        user,
        userInfo,
    ]);
    return _jsx(AuthContext.Provider, __assign({ value: value }, { children: children }));
};
export var useAuth = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
